<template>
  <div
    :class="classes(n('action'))"
    @click="onClick"
    role="button"
    :aria-label="`${action.name || ''}${action.subname || ''}`"
    aria-merge="true">
    <div :class="classes(n('action-content'))">
      <component
        :is="action.icon"
        v-if="action.icon"
        :class="classes(n('action-icon'))"
        width="1.5em"
        height="1.5em"
        :style="{ color: action.color }"
      />
      <div :class="classes(n('action-name'))" :style="{ color: action.color }">
        {{ action.name }}
      </div>
    </div>
    <div :class="classes(n('action-content'))">
      <div :class="classes(n('action-subname'))">
        {{ action.subname }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'virtual-vue';
import { actionSheetActionItemEmits } from './emits';
import { createNamespace } from '../utils/components';
import { ActionSheetAction } from './action-sheet';

const { name, n, classes } = createNamespace('action-sheet');

export default defineComponent({
  name,
  props: {
    action: {
      type: Object as PropType<ActionSheetAction>,
      default: () => ({}),
    },
  },
  emits: actionSheetActionItemEmits,
  setup(props, { emit }) {
    function onClick() {
      emit('click', props.action);
    }
    return {
      n,
      classes,
      onClick,
    };
  },
});
</script>
